import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServicioDatosBase } from '../libs/ruvpp-angular2-comun/ServicioDatosBase';
import { Usuario, SeguridadSalida, OutputVistaInformacionGeneral, InputVistaInformacionGeneral, InputReporte, OutputReporteInicioObra, InputReporteInicioObra, InputReporteAvanceObra, OutputReporteAvanceObra, OutputReporteHabitabilidad, InputReporteHabitabilidad, OutputReporteEcotecnologia, InputReporteEcotecnologia, OutputReporteVerticalidad, InputReporteVerticalidad, OutputReporteSiseviveEcocasa, InputReporteSiseviveEcocasa, OutputReporteFuncionamiento, InputReporteFuncionamiento, Archivo, OutputReporteDonacionesEquipamiento, InputReporteDonacionesEquipamiento } from '../modelo/interfaces';
import { JsonResponse } from '../libs/ruvpp-angular2-comun/modelo/Index';

@Injectable({
    providedIn: 'root'
})
export class VerificacionObraService extends ServicioDatosBase {

    private urlBase: string = environment.urlBase;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*' });

    private urls = {
        ObtenerUsuario: `${this.urlBase}/externo/api/autentificacion/ObtenerUsuario`,
        ObtenerVistaInformacionGeneral: `${this.urlBase}/externo/api/verificacionObra/ObtenerVistaInformacionGeneral`,
        ObtenerReporteInicioObra: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteInicioObra`,
        GuardarReporteInicioObra: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteInicioObra`,
        ObtenerReporteAvanceObra: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteAvanceObra`,
        GuardarReporteAvanceObra: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteAvanceObra`,
        ObtenerReporteHabitabilidad: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteHabitabilidad`,
        GuardarReporteHabitabilidad: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteHabitabilidad`,
        ObtenerReporteEcotecnologia: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteEcotecnologia`,
        GuardarReporteEcotecnologia: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteEcotecnologia`,
        ObtenerReporteVerticalidad: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteVerticalidad`,
        GuardarReporteVerticalidad: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteVerticalidad`,
        ObtenerReporteSiseviveEcocasa: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteSiseviveEcocasa`,
        GuardarReporteSiseviveEcocasa: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteSiseviveEcocasa`,
        ObtenerReporteFuncionamiento: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteFuncionamiento`,
        GuardarReporteFuncionamiento: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteFuncionamiento`,
        ObtenerReporteDonacionesEquipamiento: `${this.urlBase}/externo/api/verificacionObra/ObtenerReporteDonacionesEquipamiento`,
        GuardarReporteDonacionesEquipamiento: `${this.urlBase}/externo/api/verificacionObra/GuardarReporteDonacionesEquipamiento`,
        FileUpload: `${this.urlBase}/externo/api/fileUpload/add`,
    };


    /**
     * 
     * @param http
     */
    constructor(http: HttpClient) {
        super(http);
    }

    /**
     * 
     * @param entity
     */
    public Autentificacion(entity: Usuario) {
        return this.post<JsonResponse<SeguridadSalida>>(this.urls.ObtenerUsuario, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     */
    public ObtenerVistaInformacionGeneral(entity: InputVistaInformacionGeneral) {
        return this.post<JsonResponse<OutputVistaInformacionGeneral[]>>(this.urls.ObtenerVistaInformacionGeneral, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerReporteInicioObra(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteInicioObra>>(this.urls.ObtenerReporteInicioObra, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteInicioObra(entity: InputReporteInicioObra) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteInicioObra, JSON.stringify(entity), { headers: this.headers });
    }

    /**
    * 
    * @param entity
    */
    public ObtenerReporteAvanceObra(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteAvanceObra>>(this.urls.ObtenerReporteAvanceObra, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteAvanceObra(entity: InputReporteAvanceObra) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteAvanceObra, JSON.stringify(entity), { headers: this.headers });
    }

    /**
   * 
   * @param entity
   */
    public ObtenerReporteHabitabilidad(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteHabitabilidad>>(this.urls.ObtenerReporteHabitabilidad, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteHabitabilidad(entity: InputReporteHabitabilidad) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteHabitabilidad, JSON.stringify(entity), { headers: this.headers });
    }


    /**
     * 
     * @param entity
     */
    public ObtenerReporteEcotecnologia(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteEcotecnologia>>(this.urls.ObtenerReporteEcotecnologia, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteEcotecnologia(entity: InputReporteEcotecnologia) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteEcotecnologia, JSON.stringify(entity), { headers: this.headers });
    }

    /**
    * 
    * @param entity
    */
    public ObtenerReporteVerticalidad(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteVerticalidad>>(this.urls.ObtenerReporteVerticalidad, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteVerticalidad(entity: InputReporteVerticalidad) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteVerticalidad, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerReporteSiseviveEcocasa(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteSiseviveEcocasa>>(this.urls.ObtenerReporteSiseviveEcocasa, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteSiseviveEcocasa(entity: InputReporteSiseviveEcocasa) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteSiseviveEcocasa, JSON.stringify(entity), { headers: this.headers });
    }

    /**
   * 
   * @param entity
   */
    public ObtenerReporteFuncionamiento(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteFuncionamiento>>(this.urls.ObtenerReporteFuncionamiento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteFuncionamiento(entity: InputReporteFuncionamiento) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteFuncionamiento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public ObtenerReporteDonacionesEquipamiento(entity: InputReporte) {
        return this.post<JsonResponse<OutputReporteDonacionesEquipamiento>>(this.urls.ObtenerReporteDonacionesEquipamiento, JSON.stringify(entity), { headers: this.headers });
    }

    /**
     * 
     * @param entity
     */
    public GuardarReporteDonacionesEquipamiento(entity: InputReporteDonacionesEquipamiento) {
        return this.post<JsonResponse<boolean>>(this.urls.GuardarReporteDonacionesEquipamiento, JSON.stringify(entity), { headers: this.headers });
    }
    

    /**
     * 
     * @param event
     * @param params
     */
    public AgregarDocumento(event, params) {

        console.log('uploadFiles -->>  event -->> ', event + '    params -->> ', params);

        var formData: FormData = new FormData();

        if (params != null) {
            formData.append('json', JSON.stringify(params));
        }

        let cont = 1;

        for (let file of event.files) {

            formData.append(file.name, file);

            console.log('File [' + (cont) + ']   -->> ', file);

            cont++;

        }

        return this.postFile<JsonResponse<Archivo[]>>(this.urls.FileUpload, formData);
    }
}
